    <p *ngIf="!sections.length" class="text-500 text-sm">
      No sections yet — the page renders empty. Add a hero and some sections.
    </p>

    <div *ngFor="let s of sections; let i = index" class="section-card border-1 border-200 border-round p-3 mb-3" [attr.data-section-id]="s.id">

      <!-- Card header: accordion toggle + what this section is + move/remove.
           The action buttons stop propagation so moving/removing never also
           flips the card open. -->
      <div class="flex align-items-center justify-content-between cursor-pointer"
        [class.mb-2]="!s.collapsed" (click)="s.collapsed = !s.collapsed">
        <div class="flex align-items-center gap-2 min-w-0 flex-1 pr-2">
          <i class="pi text-500" [ngClass]="s.collapsed ? 'pi-chevron-right' : 'pi-chevron-down'" style="font-size: 0.8rem"></i>
          <span class="font-medium text-700 white-space-nowrap">
            <i class="pi mr-1" [ngClass]="s.type === 'editorial-hero' ? 'pi-image' : 'pi-align-left'"></i>
            {{ sectionSummary(s) }}
          </span>
          <span class="text-500 text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis"
            [class.font-italic]="!s.heading">— {{ s.heading || 'no heading' }}</span>
        </div>
        <div class="flex gap-1" (click)="$event.stopPropagation()">
          <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-rounded p-button-text p-button-sm"
            [disabled]="!canMoveSection(i, -1)" (click)="moveSection(i, -1)" title="Move up"></button>
          <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-rounded p-button-text p-button-sm"
            [disabled]="!canMoveSection(i, 1)" (click)="moveSection(i, 1)" title="Move down"></button>
          <button *ngIf="canRemove(s)" pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm"
            (click)="removeSection(i)" title="Remove section"></button>
        </div>
      </div>

      <ng-container *ngIf="!s.collapsed">

      <!-- ── Editorial hero fields ── -->
      <ng-container *ngIf="s.type === 'editorial-hero'">
        <div class="formgrid grid">
          <div class="field col-12 md:col-4">
            <label class="text-600 text-sm">Eyebrow (small line above the headline)</label>
            <div class="flex gap-1"><input #eyebrow pInputText type="text" class="inputfield w-full" [(ngModel)]="s.eyebrow" [ngModelOptions]="{ standalone: true }" placeholder="Questions &amp; answers" />
              <app-placeholder-menu *ngIf="showsPlaceholders" (pick)="s.eyebrow = withToken(s.eyebrow, $event, eyebrow)"></app-placeholder-menu></div>
          </div>
          <div class="field col-12 md:col-8">
            <label class="text-600 text-sm">Headline (the page's h1)</label>
            <div class="flex gap-1"><input #headline pInputText type="text" class="inputfield w-full" [(ngModel)]="s.heading" [ngModelOptions]="{ standalone: true }" placeholder="Frequently asked questions" />
              <app-placeholder-menu *ngIf="showsPlaceholders" (pick)="s.heading = withToken(s.heading, $event, headline)"></app-placeholder-menu></div>
            <!-- Text style only (Robin, 2026-10-29): the site renders bold and italic here, never colour. -->
            <small class="block text-500 mt-1">**bold** and *italic* work here. Italic shows in the brand's serif italic.</small>
          </div>
          <!-- Robin, 2026-10-29: the eyebrow follows the headline. Blank buttons are left (Ivan), whatever the headline does. -->
          <div class="field col-6 md:col-4">
            <label class="text-600 text-sm">Headline alignment</label>
            <p-dropdown [options]="alignOptions" [(ngModel)]="s.align" [ngModelOptions]="{ standalone: true }"
              optionLabel="label" optionValue="value" placeholder="Left (default)"
              styleClass="w-full" appendTo="body" data-testid="hero-align"></p-dropdown>
          </div>
          <div class="field col-6 md:col-4">
            <label class="text-600 text-sm">Button alignment</label>
            <p-dropdown [options]="alignOptions" [(ngModel)]="s.buttonAlign" [ngModelOptions]="{ standalone: true }"
              optionLabel="label" optionValue="value" placeholder="Left (default)"
              styleClass="w-full" appendTo="body" data-testid="hero-button-align"></p-dropdown>
          </div>
          <div *ngIf="!showsLead(s)" class="field col-12 text-500 text-sm">The lead under the headline is each suburb's opening paragraph (its Page tab), else the one the website writes from the nearest places.</div>
          <div class="field col-12" *ngIf="showsLead(s)">
            <label class="text-600 text-sm">Lead paragraph</label>
            <!-- Markdown (Robin, 2026-10-29), previewed on the hero's blue panel. -->
            <app-markdown-editor
              [(ngModel)]="s.copy"
              [ngModelOptions]="{ standalone: true }"
              [heightRem]="5"
              [autoGrow]="true"
              previewBackground="blue"
              previewTextColour="off-white"
              placeholder="One or two sentences under the headline. End a line with \ for a line break."
              data-testid="hero-lead"
            ></app-markdown-editor>
          </div>
          <div class="field col-12 md:col-8">
            <label class="text-600 text-sm">Hero image</label>
            <div class="flex align-items-center gap-3">
              <img *ngIf="s.heroPreview" [src]="s.heroPreview" alt="Preview" style="height: 48px; width: auto; border-radius: 6px;" />
              <span *ngIf="!s.heroPreview && s.image" class="text-500 text-sm font-mono">{{ s.image }}</span>
              <button pButton pRipple type="button" [label]="s.heroFileId ? 'Replace image' : 'Upload image'" icon="pi pi-upload"
                class="p-button-outlined p-button-sm" (click)="uploadSectionImage(s)"></button>
              <button *ngIf="s.heroFileId" pButton pRipple type="button" label="Remove" class="p-button-text p-button-danger p-button-sm"
                (click)="removeSectionImage(s)"></button>
            </div>
            <small *ngIf="s.image && !s.heroFileId" class="block text-500 mt-1">Currently using a built-in site image — uploading replaces it.</small>
          </div>
          <div class="field col-12 md:col-4">
            <label class="text-600 text-sm">Image description (accessibility)</label>
            <input pInputText type="text" class="inputfield w-full" [(ngModel)]="s.imageAlt" [ngModelOptions]="{ standalone: true }" placeholder="Lit candles at a ceremony" />
          </div>

          <div class="field col-12">
            <label class="text-600 text-sm">Buttons (up to 2 — first is the solid one)</label>
            <div *ngFor="let b of s.buttons; let bi = index" class="flex gap-2 mb-2 align-items-start">
              <input #buttonLabel pInputText type="text" class="inputfield flex-1" [(ngModel)]="b.label" [ngModelOptions]="{ standalone: true }" placeholder="Ask us directly" />
              <app-placeholder-menu *ngIf="showsPlaceholders" (pick)="b.label = withToken(b.label, $event, buttonLabel)"></app-placeholder-menu>
              <app-target-input class="flex-1" [(ngModel)]="b.target" [ngModelOptions]="{ standalone: true }"
                (pageSelected)="applyPickedLabel(b, $event)" placeholder="/contact"></app-target-input>
              <button pButton pRipple type="button" icon="pi pi-times" class="p-button-text p-button-danger" (click)="removeButton(s, bi)"></button>
            </div>
            <button *ngIf="(s.buttons?.length || 0) < 2" pButton pRipple type="button" label="Add button" icon="pi pi-plus"
              class="p-button-text p-button-sm" (click)="addButton(s)"></button>
          </div>
        </div>
      </ng-container>

      <!-- ── Standard section fields ── -->
      <ng-container *ngIf="s.type === 'section'">
        <div class="formgrid grid">
          <div class="field col-12 md:col-4">
            <label class="text-600 text-sm">Building block</label>
            <p-dropdown [options]="componentGroups" [group]="true" [(ngModel)]="s.component" [ngModelOptions]="{ standalone: true }"
              [filter]="true" filterBy="label" filterPlaceholder="Search blocks…" [autofocusFilter]="false"
              [showClear]="true" placeholder="Text only" styleClass="w-full" appendTo="body"
              (onChange)="onComponentChanged()" (onClear)="onComponentChanged()"></p-dropdown>
            <small *ngIf="isSelfContained(s)" class="block text-500 mt-1">
              This block renders its own complete section — the heading and copy below aren't shown.
            </small>
          </div>
          <div class="field col-12 md:col-8" *ngIf="!isSelfContained(s)">
            <label class="text-600 text-sm">{{ headingLabel(s) }}</label>
            <div class="flex gap-1"><input #heading pInputText type="text" class="inputfield w-full" [(ngModel)]="s.heading" [ngModelOptions]="{ standalone: true }" placeholder="Still have a question?" />
              <app-placeholder-menu *ngIf="showsPlaceholders" (pick)="s.heading = withToken(s.heading, $event, heading)"></app-placeholder-menu></div>
          </div>
          <!-- A template's text block (#262): its paragraph is the suburb's own About text, or none. -->
          <div class="field col-12 md:col-6" *ngIf="showBind(s)">
            <label class="text-600 text-sm">Fills from</label>
            <p-dropdown [options]="bindOptions" [(ngModel)]="s.bind" [ngModelOptions]="{ standalone: true }" optionLabel="label" optionValue="value"
              placeholder="Nothing (the heading and links only)" styleClass="w-full template-bind" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1">A suburb whose About text is empty doesn't show this block.</small>
          </div>
          <!-- The block's look (Robin, 2026-10-29): colours on every block, the
               heading's colour/level/alignment where the site renders the
               heading, buttons/spacing/divider on standard blocks. -->
          <app-block-look class="col-12" [section]="s" [headingControls]="showAlign(s)"
            [blockControls]="!isSelfContained(s)"></app-block-look>

          <!-- Scope pickers, not free text: a typo here renders an empty list
               or silently the wrong area's content. Blank = derive the scope
               from the page's own address (right on region/suburb pages). -->
          <div class="field col-4" *ngIf="showAreaScope(s)">
            <label class="text-600 text-sm">State</label>
            <p-dropdown [options]="scopeStateOptions" [(ngModel)]="s.state" [ngModelOptions]="{ standalone: true }"
              optionLabel="label" optionValue="value" placeholder="Automatic (from the page address)"
              styleClass="w-full" appendTo="body"></p-dropdown>
          </div>
          <div class="field col-4" *ngIf="showScopeRegion(s)">
            <label class="text-600 text-sm">Region</label>
            <p-dropdown [options]="scopeRegionOptions" [(ngModel)]="s.region" [ngModelOptions]="{ standalone: true }"
              optionLabel="label" optionValue="value" placeholder="Automatic (from the page address)"
              styleClass="w-full" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1" *ngIf="s.component === 'directors-grid'">
              Shows the directors who serve this region.
            </small>
          </div>
          <div class="field col-4" *ngIf="s.component === 'venues-list'">
            <label class="text-600 text-sm">Suburb</label>
            <p-dropdown [options]="scopeSuburbOptions" [(ngModel)]="s.suburb" [ngModelOptions]="{ standalone: true }"
              optionLabel="label" optionValue="value" placeholder="Automatic (from the page address)"
              [filter]="true" filterBy="label"
              styleClass="w-full" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1">Narrowest wins — a suburb overrides the region.</small>
          </div>

          <div class="field col-12 md:col-4" *ngIf="showSingleService(s)">
            <label class="text-600 text-sm">Service id (from Website services)</label>
            <input pInputText type="text" class="inputfield w-full font-mono" [(ngModel)]="s.service" [ngModelOptions]="{ standalone: true }"
              placeholder="direct-cremation" />
          </div>

          <!-- service-hero: the hero image + eyebrow live on the section like
               an editorial hero; the lead, price CTA and schema come from the
               service record. Without an image it renders as a text banner. -->
          <ng-container *ngIf="showHeroFields(s)">
            <div class="field col-12 md:col-4">
              <label class="text-600 text-sm">Eyebrow (small label above the h1)</label>
              <input pInputText type="text" class="inputfield w-full" [(ngModel)]="s.eyebrow" [ngModelOptions]="{ standalone: true }" placeholder="Cremation" />
            </div>
            <div class="field col-12 md:col-8">
              <label class="text-600 text-sm">Hero image</label>
              <div class="flex align-items-center gap-3">
                <img *ngIf="s.heroPreview" [src]="s.heroPreview" alt="Preview" style="height: 48px; width: auto; border-radius: 6px;" />
                <span *ngIf="!s.heroPreview && s.image" class="text-500 text-sm font-mono">{{ s.image }}</span>
                <button pButton pRipple type="button" [label]="s.heroFileId ? 'Replace image' : 'Upload image'" icon="pi pi-upload"
                  class="p-button-outlined p-button-sm" (click)="uploadSectionImage(s)"></button>
                <button *ngIf="s.heroFileId || s.image" pButton pRipple type="button" label="Remove" class="p-button-text p-button-danger p-button-sm"
                  (click)="removeSectionImage(s)"></button>
              </div>
              <small *ngIf="s.image && !s.heroFileId" class="block text-500 mt-1">Currently using a built-in site image — uploading replaces it.</small>
            </div>
            <div class="field col-12 md:col-4">
              <label class="text-600 text-sm">Image description (accessibility)</label>
              <input pInputText type="text" class="inputfield w-full" [(ngModel)]="s.imageAlt" [ngModelOptions]="{ standalone: true }" placeholder="A wicker coffin among coastal grasses" />
            </div>
          </ng-container>

          <!-- Plain text sections can carry a figure image, shown after the
               copy (the about-page style). -->
          <ng-container *ngIf="showSectionImage(s)">
            <div class="field col-12 md:col-8">
              <label class="text-600 text-sm">Section image (optional — shown under the copy)</label>
              <div class="flex align-items-center gap-3">
                <img *ngIf="s.heroPreview" [src]="s.heroPreview" alt="Preview" style="height: 48px; width: auto; border-radius: 6px;" />
                <span *ngIf="!s.heroPreview && s.image" class="text-500 text-sm font-mono">{{ s.image }}</span>
                <button pButton pRipple type="button" [label]="s.heroFileId ? 'Replace image' : 'Upload image'" icon="pi pi-upload"
                  class="p-button-outlined p-button-sm" (click)="uploadSectionImage(s)"></button>
                <button *ngIf="s.heroFileId || s.image" pButton pRipple type="button" label="Remove" class="p-button-text p-button-danger p-button-sm"
                  (click)="removeSectionImage(s)"></button>
              </div>
              <small *ngIf="s.image && !s.heroFileId" class="block text-500 mt-1">Currently using a built-in site image — uploading replaces it.</small>
            </div>
            <div class="field col-12 md:col-4" *ngIf="s.image || s.heroFileId">
              <label class="text-600 text-sm">Image description (accessibility)</label>
              <input pInputText type="text" class="inputfield w-full" [(ngModel)]="s.imageAlt" [ngModelOptions]="{ standalone: true }" placeholder="What the photo shows" />
            </div>
            <!-- Only offered once there IS an image — the same gate the alt
                 field uses. Blank keeps the old behaviour (under everything). -->
            <div class="field col-12 md:col-4" *ngIf="s.image || s.heroFileId">
              <label class="text-600 text-sm">Image position</label>
              <p-dropdown [options]="imageLayoutOptions" [(ngModel)]="s.imageLayout" [ngModelOptions]="{ standalone: true }"
                optionLabel="label" optionValue="value" placeholder="Under everything" [showClear]="true"
                appendTo="body" styleClass="w-full"></p-dropdown>
              <small class="block text-500 mt-1">Beside the text, the image and the words share the row evenly; on a phone they stack.</small>
            </div>
          </ng-container>

          <!-- Plain textarea where the site renders copy as text, Markdown
               editor where it renders it as Markdown — offering formatting
               that ships as literal asterisks is worse than not offering it. -->
          <div class="field col-12" *ngIf="!isSelfContained(s) && !hidesCopy(s) && usesPlainCopy(s)">
            <label class="text-600 text-sm">Copy</label>
            <textarea pInputTextarea [autoResize]="true" rows="3" class="inputfield w-full" [(ngModel)]="s.copy" [ngModelOptions]="{ standalone: true }"
              placeholder="Plain text shown under the heading."></textarea>
            <small class="block text-500 mt-1">This block shows plain text only — no formatting.</small>
          </div>

          <div class="field col-12" *ngIf="!isSelfContained(s) && !hidesCopy(s) && !usesPlainCopy(s)">
            <label class="text-600 text-sm">Copy</label>
            <app-markdown-editor
              [(ngModel)]="s.copy"
              [ngModelOptions]="{ standalone: true }"
              [heightRem]="7.5"
              [autoGrow]="true"
              imageBucketPrefix="page-body"
              [imageAltFallback]="s.heading || 'Page image'"
              [previewBackground]="s.background"
              [previewTextColour]="s.textColour"
              placeholder="The section's copy. Headings, bold, links, lists and images all work."
            ></app-markdown-editor>
          </div>

          <div class="field col-6 md:col-3" *ngIf="showWideColumns(s)">
            <label class="text-600 text-sm">Columns</label>
            <p-dropdown [options]="wideColumnOptions" [(ngModel)]="s.columns" [ngModelOptions]="{ standalone: true }"
              optionLabel="label" optionValue="value" [showClear]="true" placeholder="2 (default)"
              styleClass="w-full" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1">Desktop only — phones stay narrower whatever you pick.</small>
          </div>

          <!-- Component options, shown only where that component reads them -->
          <div class="field col-6 md:col-3" *ngIf="showFuneralCostRegion(s)">
            <label class="text-600 text-sm">Pricing region</label>
            <p-dropdown [options]="packageRegionOptions" [(ngModel)]="s.region" [ngModelOptions]="{ standalone: true }"
              optionLabel="label" optionValue="value" placeholder="Global (mainline prices)"
              styleClass="w-full" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1">Which region's funeral costs to show. A region with none falls back to the global set.</small>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showVariant(s)">
            <label class="text-600 text-sm">Funeral Costs layout</label>
            <p-dropdown [options]="variantOptions" [(ngModel)]="s.variant" [ngModelOptions]="{ standalone: true }"
              [showClear]="true" placeholder="Condensed strip" styleClass="w-full" appendTo="body"></p-dropdown>
          </div>
          <!-- Which costs (Robin, 2026-10-29): burial was showing on the cremation pages. By name, so one pick covers
               every region's record of that cost. -->
          <div class="field col-12 md:col-6" *ngIf="showVariant(s)">
            <label class="text-600 text-sm">Costs shown</label>
            <p-multiSelect [options]="costOptions" [(ngModel)]="s.costs" [ngModelOptions]="{ standalone: true }"
              defaultLabel="All costs" display="chip" [showToggleAll]="false" [filter]="false"
              styleClass="w-full" appendTo="body" data-testid="funeral-costs-shown"></p-multiSelect>
            <small class="block text-500 mt-1">Pick the costs this block shows, e.g. only burial on a burial page. None picked shows them all.</small>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showBlogColumns(s)">
            <label class="text-600 text-sm">Blog layout</label>
            <p-dropdown [options]="blogVariantOptions" [(ngModel)]="s.variant" [ngModelOptions]="{ standalone: true }"
              [showClear]="true" placeholder="Teaser (a few of the newest)" styleClass="w-full" appendTo="body"></p-dropdown>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showBlogColumns(s)">
            <label class="text-600 text-sm">Columns</label>
            <p-dropdown [options]="panelColumnOptions" [(ngModel)]="s.columns" [ngModelOptions]="{ standalone: true }"
              [showClear]="true" placeholder="3 (default)" styleClass="w-full" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1">Desktop only — phones always show one.</small>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showBlogRows(s)">
            <label class="text-600 text-sm">Rows</label>
            <p-dropdown [options]="panelRowOptions" [(ngModel)]="s.rows" [ngModelOptions]="{ standalone: true }"
              [showClear]="true" placeholder="1 row" styleClass="w-full" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1">Shows at most columns × rows articles.</small>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showLimit(s)">
            <label class="text-600 text-sm">Show at most</label>
            <input pInputText type="number" min="1" class="inputfield w-full" [(ngModel)]="s.limit" [ngModelOptions]="{ standalone: true }" placeholder="all" />
          </div>
          <div class="field col-6 md:col-3" *ngIf="showShowMax(s)">
            <label class="text-600 text-sm">Show at first</label>
            <input pInputText type="number" min="1" class="inputfield w-full" [(ngModel)]="s.showMax" [ngModelOptions]="{ standalone: true }" placeholder="all" />
            <small class="block text-500 mt-1">e.g. 4 or 6 — the rest sit behind a "Show more" button.</small>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showPanels(s)">
            <label class="text-600 text-sm">Columns</label>
            <p-dropdown [options]="panelColumnOptions" [(ngModel)]="s.columns" [ngModelOptions]="{ standalone: true }"
              [showClear]="true" placeholder="Auto (by panel count)" styleClass="w-full" appendTo="body"></p-dropdown>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showPanels(s)">
            <label class="text-600 text-sm">Rows</label>
            <p-dropdown [options]="panelRowOptions" [(ngModel)]="s.rows" [ngModelOptions]="{ standalone: true }"
              [showClear]="true" placeholder="All panels" styleClass="w-full" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1">Shows at most columns × rows panels.</small>
          </div>
          <!-- Panel colours (#264): every panel, unless it picks its own below.
               Blank = the plain card the site has always shown. -->
          <div class="field col-6 md:col-3" *ngIf="showPanels(s)">
            <label class="text-600 text-sm">Panel background</label>
            <app-colour-select [options]="backgroundOptions" [(ngModel)]="s.panelBackground" [ngModelOptions]="{ standalone: true }"
              placeholder="None (plain card)" data-testid="panel-background"></app-colour-select>
            <small class="block text-500 mt-1">Every panel, unless it picks its own.</small>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showPanels(s)">
            <label class="text-600 text-sm">Panel text colour</label>
            <app-colour-select [options]="textColourOptions" [(ngModel)]="s.panelTextColour" [ngModelOptions]="{ standalone: true }"
              placeholder="Automatic" data-testid="panel-text-colour"></app-colour-select>
            <small class="block text-500 mt-1">Automatic = off-white on dark backgrounds.</small>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showGalleryFields(s)">
            <label class="text-600 text-sm">Gallery layout</label>
            <p-dropdown [options]="galleryVariantOptions" [(ngModel)]="s.variant" [ngModelOptions]="{ standalone: true }"
              [showClear]="true" placeholder="Grid" styleClass="w-full" appendTo="body"></p-dropdown>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showGalleryColumns(s)">
            <label class="text-600 text-sm">Columns</label>
            <p-dropdown [options]="panelColumnOptions" [(ngModel)]="s.columns" [ngModelOptions]="{ standalone: true }"
              [showClear]="true" placeholder="3 (default)" styleClass="w-full" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1">Desktop only — phones always show 1–2.</small>
          </div>
          <div class="field col-6 md:col-3" *ngIf="showPerPage(s)">
            <label class="text-600 text-sm">Articles per page <span class="text-500">(full page only)</span></label>
            <input pInputText type="number" min="1" class="inputfield w-full" [(ngModel)]="s.perPage" [ngModelOptions]="{ standalone: true }" placeholder="24" />
          </div>
          <div class="field col-6 md:col-3 flex align-items-end gap-3" *ngIf="showDirectorFlags(s)">
            <span class="flex align-items-center gap-2">
              <p-inputSwitch [(ngModel)]="s.shuffle" [ngModelOptions]="{ standalone: true }"></p-inputSwitch>
              <span class="text-600 text-sm">Rotate daily</span>
            </span>
            <span class="flex align-items-center gap-2">
              <p-inputSwitch [(ngModel)]="s.photosOnly" [ngModelOptions]="{ standalone: true }"></p-inputSwitch>
              <span class="text-600 text-sm">Photos only</span>
            </span>
          </div>

          <!-- ── Photo gallery images ── -->
          <div class="field col-12" *ngIf="showGalleryFields(s)">
            <label class="text-600 text-sm">Images (shown in this order)</label>
            <div *ngFor="let im of s.images ?? []; let gi = index" class="flex align-items-center gap-2 mb-2">
              <img *ngIf="im.preview" [src]="im.preview" alt="Preview" style="height: 44px; width: 66px; object-fit: cover; border-radius: 4px;" />
              <span *ngIf="!im.preview" class="text-500 text-sm">#{{ im.fileId }}</span>
              <input pInputText type="text" class="inputfield" style="flex: 1" [(ngModel)]="im.alt" [ngModelOptions]="{ standalone: true }" placeholder="Image description (accessibility)" />
              <input pInputText type="text" class="inputfield" style="flex: 1" [(ngModel)]="im.caption" [ngModelOptions]="{ standalone: true }" placeholder="Caption (optional, shown under the photo)" />
              <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-rounded p-button-text p-button-sm" [disabled]="gi === 0" (click)="moveGalleryImage(s, gi, -1)"></button>
              <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-rounded p-button-text p-button-sm" [disabled]="gi === (s.images ?? []).length - 1" (click)="moveGalleryImage(s, gi, 1)"></button>
              <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm" (click)="removeGalleryImage(s, gi)"></button>
            </div>
            <button pButton pRipple type="button" label="Add images" icon="pi pi-upload" class="p-button-outlined p-button-sm" (click)="addGalleryImages(s)"></button>
            <small class="block text-500 mt-1">JPG, PNG, WebP or AVIF. The description is read aloud by screen readers and read by search engines.</small>
          </div>

          <!-- ── Downloads documents ── -->
          <div class="field col-12" *ngIf="showDownloadFields(s)">
            <label class="text-600 text-sm">Documents (shown in this order)</label>
            <div *ngFor="let f of s.files ?? []; let fi = index" class="flex align-items-center gap-2 mb-2">
              <i class="pi pi-file-pdf text-500"></i>
              <input pInputText type="text" class="inputfield" style="flex: 2" [(ngModel)]="f.label" [ngModelOptions]="{ standalone: true }" placeholder="Label people click, e.g. Funeral planning brochure" />
              <span class="text-500 text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis" style="max-width: 14rem">{{ f.fileName || '#' + f.fileId }}</span>
              <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-rounded p-button-text p-button-sm" [disabled]="fi === 0" (click)="moveDownloadFile(s, fi, -1)"></button>
              <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-rounded p-button-text p-button-sm" [disabled]="fi === (s.files ?? []).length - 1" (click)="moveDownloadFile(s, fi, 1)"></button>
              <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm" (click)="removeDownloadFile(s, fi)"></button>
            </div>
            <button pButton pRipple type="button" label="Add documents" icon="pi pi-upload" class="p-button-outlined p-button-sm" (click)="addDownloadFiles(s)"></button>
            <small class="block text-500 mt-1">PDF and Word documents. People download them from the page.</small>
          </div>

          <div class="field col-12" *ngIf="showPanels(s)">
            <label class="text-600 text-sm">Panels (up to {{ panelCap(s) }}; each needs a heading, everything else is optional)</label>
            <p *ngIf="panelsOverCap(s)" class="text-sm mt-1 mb-2 p-2 border-round"
              style="background: var(--yellow-50); color: var(--yellow-900);">
              <i class="pi pi-exclamation-triangle mr-1"></i>
              This grid shows {{ panelCap(s) }} panels, so the last {{ panelsOverCap(s) }}
              will not appear on the site. They are still saved — widen the grid or remove them.
            </p>
            <div *ngFor="let p of s.panels; let pi = index" class="border-1 border-200 border-round p-2 mb-2" data-testid="panel">
              <div class="flex gap-2 mb-2">
                <input pInputText type="text" class="inputfield" style="flex: 1" [(ngModel)]="p.heading" [ngModelOptions]="{ standalone: true }" placeholder="Panel heading" />
                <textarea pInputTextarea [autoResize]="true" rows="1" class="inputfield" style="flex: 2" [(ngModel)]="p.copy" [ngModelOptions]="{ standalone: true }" placeholder="Panel copy (optional)"></textarea>
                <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-rounded p-button-text p-button-sm" [disabled]="pi === 0" (click)="movePanel(s, pi, -1)"></button>
                <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-rounded p-button-text p-button-sm" [disabled]="pi === (s.panels ?? []).length - 1" (click)="movePanel(s, pi, 1)"></button>
                <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm" (click)="removePanel(s, pi)"></button>
              </div>
              <div class="flex align-items-start gap-2">
                <img *ngIf="p.preview" [src]="p.preview" alt="Preview" style="height: 36px; width: 54px; object-fit: cover; border-radius: 4px;" />
                <button pButton pRipple type="button" [label]="p.imageFileId ? 'Replace image' : 'Add image'" icon="pi pi-upload"
                  class="p-button-text p-button-sm" (click)="uploadPanelImage(p)"></button>
                <button *ngIf="p.imageFileId" pButton pRipple type="button" icon="pi pi-times" class="p-button-text p-button-danger p-button-sm" (click)="removePanelImage(p)"></button>
                <input *ngIf="p.imageFileId" pInputText type="text" class="inputfield" style="flex: 1" [(ngModel)]="p.imageAlt" [ngModelOptions]="{ standalone: true }" placeholder="Image description (accessibility)" />
                <input pInputText type="text" class="inputfield" style="flex: 1" [ngModelOptions]="{ standalone: true }"
                  [ngModel]="p.link?.label" (ngModelChange)="ensurePanelLink(p); p.link!.label = $event" placeholder="Link text (optional)" />
                <app-target-input style="flex: 1" [ngModelOptions]="{ standalone: true }"
                  [ngModel]="p.link?.target" (ngModelChange)="ensurePanelLink(p); p.link!.target = $event"
                  (pageSelected)="applyPickedLabel(p.link, $event)" placeholder="/contact or https://…"></app-target-input>
              </div>
              <!-- This panel's own colours (#264); blank inherits the block's. -->
              <div class="grid mt-2">
                <div class="col-12 md:col-6">
                  <label class="text-600 text-sm">Background</label>
                  <app-colour-select [options]="backgroundOptions" [(ngModel)]="p.background" [ngModelOptions]="{ standalone: true }"
                    [placeholder]="panelBackgroundPlaceholder(s)" data-testid="panel-own-background"></app-colour-select>
                </div>
                <div class="col-12 md:col-6">
                  <label class="text-600 text-sm">Text colour</label>
                  <app-colour-select [options]="textColourOptions" [(ngModel)]="p.textColour" [ngModelOptions]="{ standalone: true }"
                    [placeholder]="panelTextColourPlaceholder(s)" data-testid="panel-own-text-colour"></app-colour-select>
                </div>
              </div>
            </div>
            <button pButton pRipple type="button" label="Add panel" icon="pi pi-plus" class="p-button-text p-button-sm"
              [disabled]="(s.panels ?? []).length >= panelCap(s)" (click)="addPanel(s)"
              [pTooltip]="(s.panels ?? []).length >= panelCap(s) ? 'This grid is full — widen it to add more' : ''"
              tooltipPosition="top"></button>
          </div>

          <div class="field col-12" *ngIf="showServices(s)">
            <label class="text-600 text-sm">Service ids (comma-separated)</label>
            <input pInputText type="text" class="inputfield w-full font-mono" [(ngModel)]="s.servicesCsv" [ngModelOptions]="{ standalone: true }"
              placeholder="direct-cremation, cremation-with-service" />
          </div>

          <div class="field col-12 md:col-6" *ngIf="s.component === 'suburb-places'">
            <label class="text-600 text-sm">Which places</label>
            <p-dropdown [options]="suburbPlacesOptions" [(ngModel)]="s.variant" [ngModelOptions]="{ standalone: true }"
              placeholder="Crematoria and cemeteries" styleClass="w-full" appendTo="body"></p-dropdown>
            <small class="block text-500 mt-1">The nearest places to this page's suburb, filled in by the website from Conductor's providers.</small>
          </div>

          <div class="field col-12 text-500 text-sm" *ngIf="readsSuburbFaqs(s)">
            Shows each suburb's FAQs, chosen on its Page tab. A suburb with none doesn't show this block.
          </div>
          <div class="formgrid grid col-12" *ngIf="showFaqs(s) && !readsSuburbFaqs(s)">
            <div class="field col-12 md:col-6">
              <label class="text-600 text-sm">Display type</label>
              <p-dropdown [options]="faqVariantOptions" [(ngModel)]="s.variant" [ngModelOptions]="{ standalone: true }"
                [showClear]="true" placeholder="Section (the FAQs picked below)" styleClass="w-full" appendTo="body"></p-dropdown>
            </div>
            <div class="field col-12 md:col-6 flex align-items-end">
              <label class="flex align-items-center gap-2 mb-2">
                <p-inputSwitch [(ngModel)]="s.groupByCategory" [ngModelOptions]="{ standalone: true }"></p-inputSwitch>
                <span class="text-600 text-sm">Group by category</span>
              </label>
            </div>
          </div>

          <div class="field col-12" *ngIf="showFaqs(s) && isFullPageFaqs(s) && !readsSuburbFaqs(s)">
            <small class="block text-500">
              Shows every FAQ with <strong>Display on the FAQ page</strong> switched on, in the
              Website FAQs order. Add or remove items there and this page follows.
            </small>
          </div>

          <div class="field col-12" *ngIf="showFaqPicker(s)">
            <label class="text-600 text-sm">FAQs to show <span class="text-500">(from the Website FAQs list)</span></label>
            <p-multiSelect [options]="faqOptions" [(ngModel)]="s.faqIds" [ngModelOptions]="{ standalone: true }"
              optionLabel="label" optionValue="value" display="chip" styleClass="w-full" appendTo="body"
              [filter]="true" filterPlaceHolder="Search questions"
              placeholder="Every FAQ assigned to this page's address"
              emptyMessage="No FAQs yet — add them under Website FAQs"></p-multiSelect>
            <small class="block text-500 mt-1">
              The order follows the Website FAQs list, not the order you pick them in.
            </small>
          </div>

          <div class="formgrid grid col-12" *ngIf="showYouTube(s)">
            <div class="field col-12 md:col-7">
              <label class="text-600 text-sm">YouTube video</label>
              <input pInputText type="text" class="inputfield w-full" [(ngModel)]="s.video" [ngModelOptions]="{ standalone: true }"
                placeholder="https://www.youtube.com/watch?v=..." />
              <small class="block text-500 mt-1">
                Paste the link from YouTube — the address bar, the Share button, or an embed URL. The video id on its own works too.
              </small>
            </div>
            <div class="field col-12 md:col-5">
              <label class="text-600 text-sm">Caption <span class="text-500">(optional)</span></label>
              <input pInputText type="text" class="inputfield w-full" [(ngModel)]="s.caption" [ngModelOptions]="{ standalone: true }"
                placeholder="What the video shows" />
              <small class="block text-500 mt-1">Shown under the video, and read out by screen readers.</small>
            </div>
          </div>

          <div class="field col-12" *ngIf="showLink(s)">
            <label class="text-600 text-sm">Links and buttons under the section (optional)</label>
            <!-- One row per link, three controls on a line: label, target,
                 style. The row actions are icon-only and sit at the end, so
                 the eye runs label → where it goes → how it looks without a
                 wrap. Column headings appear once above the rows rather than
                 a placeholder repeated down every input. -->
            <div *ngIf="s.links?.length" class="flex gap-2 align-items-center px-1 mb-1">
              <span class="text-500 text-xs" style="flex: 2 1 0; min-width: 0">Label</span>
              <span class="text-500 text-xs" style="flex: 3 1 0; min-width: 0">Links to</span>
              <span class="text-500 text-xs" style="flex: 0 0 11rem">Appearance</span>
              <span style="flex: 0 0 7.5rem"></span>
            </div>
            <div *ngFor="let l of s.links; let li = index"
                 class="flex gap-2 align-items-start mb-2">
              <input #linkLabel pInputText type="text" class="inputfield" style="flex: 2 1 0; min-width: 0"
                [(ngModel)]="l.label" [ngModelOptions]="{ standalone: true }"
                placeholder="Browse all articles" />
              <app-placeholder-menu *ngIf="showsPlaceholders" (pick)="l.label = withToken(l.label, $event, linkLabel)"></app-placeholder-menu>
              <app-target-input style="flex: 3 1 0; min-width: 0" [(ngModel)]="l.target"
                [ngModelOptions]="{ standalone: true }"
                (pageSelected)="applyPickedLabel(l, $event)"
                placeholder="/blog or tel:0290679536"></app-target-input>
              <app-placeholder-menu *ngIf="showsPlaceholders" [forTarget]="true" (pick)="l.target = withTargetToken(l.target, $event)"></app-placeholder-menu>
              <!-- Wrapped: p-dropdown's [style] lands on its inner container,
                   not the flex child, so the basis has to go on a host div. -->
              <div style="flex: 0 0 11rem">
                <p-dropdown [options]="linkStyleOptions" [(ngModel)]="l.style"
                  [ngModelOptions]="{ standalone: true }" optionLabel="label" optionValue="value"
                  placeholder="Link" appendTo="body" styleClass="w-full"></p-dropdown>
              </div>
              <!-- Fixed width so the buttons line up down the column even when
                   a target-input below grows a warning line. -->
              <div class="flex align-items-center" style="flex: 0 0 7.5rem">
                <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-text p-button-sm"
                  pTooltip="Move up" [disabled]="li === 0" (click)="moveLink(s, li, -1)"></button>
                <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-text p-button-sm"
                  pTooltip="Move down" [disabled]="li === (s.links?.length || 0) - 1" (click)="moveLink(s, li, 1)"></button>
                <button pButton pRipple type="button" icon="pi pi-times" class="p-button-text p-button-danger p-button-sm"
                  pTooltip="Remove" (click)="removeLinkAt(s, li)"></button>
              </div>
            </div>
            <button pButton pRipple type="button" label="Add link or button" icon="pi pi-plus" class="p-button-text p-button-sm" (click)="addLink(s)"></button>
            <small class="block text-500 mt-1">A phone or email target works here — use <code>tel:</code> or <code>mailto:</code> and pick a button style for a call-to-action.</small>
          </div>

          <div class="field col-12 md:col-4">
            <label class="text-600 text-sm">Anchor id (optional — for #links)</label>
            <input pInputText type="text" class="inputfield w-full font-mono" [(ngModel)]="s.anchor" [ngModelOptions]="{ standalone: true }" placeholder="contact" />
          </div>
        </div>
      </ng-container>

      </ng-container>

    </div>
